import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.boltin.com';
const WEBHOOKS_PATH = '/api/webhooks';

const createWebhook = async (webhookData) => {
  const response = await axios.post(`${API_BASE_URL}${WEBHOOKS_PATH}`, webhookData);
  return response.data.data;
};

const getWebhooks = async () => {
  const response = await axios.get(`${API_BASE_URL}${WEBHOOKS_PATH}`);
  return response.data.data;
};

const deleteWebhook = async (id) => {
  const response = await axios.delete(`${API_BASE_URL}${WEBHOOKS_PATH}/${id}`);
  return response.data.data;
};

const getWebhookEvents = async () => {
  const response = await axios.get(`${API_BASE_URL}${WEBHOOKS_PATH}/events`);
  return response.data.data;
};

const webhookService = {
  createWebhook,
  getWebhooks,
  deleteWebhook,
  getWebhookEvents,
};

export default webhookService;